module.exports = __webpack_public_path__ + "media/images/icons/icon-dress-b2355a0e44a85fe7704bd6057103f117.svg";